import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Card from '../../../../Components/Card/Card';
import { FormInput } from '../../../../Components/FormComponents/Input/Input';
import SkynetIcon from '../../../../Components/Fundamentals/SkynetIcon';
import { TerminationReasonsTable } from '../../../../Components/InternalCustomerAdmin/TerminationReasons/TerminationReasonsTable';

import terminationReasonsActions from '../../../../Actions/InternalCustomerAdmin/terminationReasonsActions';
import routes from '../../../../Constants/routes';
import { useDebounce } from '../../../../Hooks/useDebounce';

const TerminationReasonsContainer = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();

    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 250);

    const terminationReasons = useSelector((state) => state.InternalCustomerAdminReducer.terminationReasons);

    useEffect(() => {
        dispatch(terminationReasonsActions.getTerminationReasons());
    }, []);

    const filteredTerminationReasons = useMemo(() => {
        if (!debouncedSearchQuery.trim()) {
            return terminationReasons;
        }

        return (
            terminationReasons?.filter(
                (reason) =>
                    reason.name.toLowerCase().includes(debouncedSearchQuery.toLowerCase()) ||
                    reason.subReasons?.some((subReason) => subReason.name.toLowerCase().includes(debouncedSearchQuery.toLowerCase()))
            ) || []
        );
    }, [terminationReasons, debouncedSearchQuery]);

    return (
        <Card>
            <Card.Header>
                <Card.Header.Title>{t('terminationreasonscontainer.header')}</Card.Header.Title>
            </Card.Header>
            <Card.Content>
                <div className="mb-6">
                    <div className="row">
                        <div className="col-8 p-0">
                            <FormInput
                                placeholder={t('terminationreasonscontainer.filterPlaceholder')}
                                className="form-control"
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e)}
                            />
                        </div>
                        <div className="col-4 text-right p-0">
                            <button className="btn btn-primary btn-sm" onClick={() => navigate(routes.icaTerminationReasonsCreate)}>
                                <SkynetIcon icon="vismaicon-add vismaicon-sm" /> {t('terminationreasonscontainer.createreason')}
                            </button>
                        </div>
                    </div>
                </div>
                <div>
                    <TerminationReasonsTable terminationReasons={filteredTerminationReasons} searchQuery={debouncedSearchQuery} />
                </div>
            </Card.Content>
        </Card>
    );
};

export default TerminationReasonsContainer;
